import { Action } from 'components/molecules/Action'
import { Section } from 'components/organisms/Section'
import { Picture } from 'components/atoms/Picture'
import type { ImageName } from 'components/atoms/Image'
import type { HeroProps } from './types'

import './index.scss'

const mainClass = 'hero'

export const Hero = ({
  subtitle,
  title,
  text,
  action,
  image,
  imageMobile,
  imageAlt = 'Hero image',
}: HeroProps) => {
  const hasBothImages = image && imageMobile

  return (
    <Section className={mainClass}>
      <div className={`${mainClass}__content`}>
        {subtitle && <p className={`${mainClass}__subtitle`}>{subtitle}</p>}
        {title && <h1 className={`${mainClass}__title`}>{title}</h1>}
        {text && <p className={`${mainClass}__text`}>{text}</p>}
        {action && (
          <div className={`${mainClass}__action-wrap`}>
            <Action action={action} className={`${mainClass}__action`} />
          </div>
        )}
      </div>

      {hasBothImages ? (
        <Picture
          className={`${mainClass}__image`}
          sources={[
            { name: imageMobile as ImageName, media: '(max-width: 768px)' },
            { name: image as ImageName, media: '(min-width: 769px)' },
          ]}
          fallback={image as ImageName}
          alt={imageAlt}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          sizes="(max-width: 768px) 100vw, 590px"
        />
      ) : image ? (
        <Picture
          className={`${mainClass}__image`}
          sources={[]}
          fallback={image as ImageName}
          alt={imageAlt}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          sizes="590px"
        />
      ) : null}
    </Section>
  )
}
